module.exports = __webpack_public_path__ + "img/seat-logo.4713fc58.svg";